import PropTypes from 'prop-types';
import { Button, Nav } from 'react-bootstrap';

import t from '../../../text';
import { Icon } from '../Icon';
import { useShowOriginalBackground } from './useShowOriginalBackground';

const BOOKING_JOURNEYS = ['/booking/', '/my-booking'];

export const HeaderNavMyBookingButton = ({ onShowMyBooking }) => {
  const { showOriginalBackground } = useShowOriginalBackground();

  const isInBookingJourney = BOOKING_JOURNEYS.includes(location.pathname);

  if (isInBookingJourney) return null;

  return (
    <Nav className="ml-2">
      <Button
        type="button"
        size="sm"
        className={showOriginalBackground ? 'd-block' : 'd-none'}
        variant="darker"
        onClick={onShowMyBooking}
      >
        <Icon icon="sign-in" /> {t('header.myBooking')}
      </Button>
    </Nav>
  );
};

HeaderNavMyBookingButton.propTypes = {
  onShowLogin: PropTypes.func,
};
